export default "__VITE_ASSET__Ds5VEK_2__"